export enum deviceMessageProperties {
  MESSAGE_ID = 'message_id',
  // PLATFORM = 'platform',
  ENVIRONMENT = 'environment',
  TERMINAL_ID = 'terminal_id',
  REQUEST_ID = 'request_id',
  RESPONSE_ID = 'response_id',
  BARCODE_DATA = 'barcode_data',
  USER_CANCEL = 'user_cancel'
}
